import loadable from '@loadable/component'
import React, { useMemo } from 'react'

import useHoveredItem from '@/common/hooks/useHoveredItem'
import { getGooglePlaceLocation } from '@/common/utils/map'
import NearbyPlaceSymbol from '@/modules/property/pages/PlaceDetailPage/components/NearbyPlaceSymbol'

import { MapWrapper } from './styled'

const GoogleMap = loadable(() => import('@/common/components/GoogleMap'), {
  ssr: false,
})

interface NearbyPlacesMapProps {
  place: RentAPerfect.Condo
  nearbyPlaces: RentAPerfect.NearbyPlace[]
}

const NearbyPlacesMap = ({ place, nearbyPlaces }: NearbyPlacesMapProps) => {
  const { hovered, getElementProps: getHoveredItemProps } = useHoveredItem()

  const markers = useMemo(
    () =>
      [
        {
          placeId: place.googlePlaceId,
          lat: place.latitude!,
          lng: place.longitude!,
          color: 'yellow',
        },
        ...nearbyPlaces.map(nearbyPlace => {
          const placeId = nearbyPlace.id
          return {
            ...getGooglePlaceLocation(nearbyPlace),
            placeId,
            bounce: false,
            type: nearbyPlace.type,
            wrapperProps: getHoveredItemProps(placeId),
            markerComponent: NearbyPlaceSymbol,
          }
        }),
      ]
        .filter(Boolean)
        .reverse(),
    [place, nearbyPlaces, getHoveredItemProps]
  )

  return (
    <MapWrapper>
      <GoogleMap
        markers={markers}
        selectedPlaceId={hovered}
        selectedPlaceProps={{ selected: true }}
      />
    </MapWrapper>
  )
}

export default NearbyPlacesMap
